<template>
  <div id="app">
    <img src="../../static/img/ejymjpg.png" style="width: 100%;">
    <div class="btcss">
      <div class="tabbox">
        <div :class="{'active':active_btn==index}" v-for="(item,index) in cplist" @click="newsList(index,item)">
          <el-tooltip class="item" effect="light" :content="item.menuName" placement="top-start">
            <span>{{item.menuName}}</span>
          </el-tooltip>
        </div>
        <div class="dqwz">首页 > 产品世界 > {{ titName }}</div>
      </div>
    </div>
    <!-- 头部 -->
    <div class="ceneterbox">
      <div class="lowerbox">
        <div class="cpb">
          <div class="cpbox" v-for="item in listData" @click="openDetails(item)">
            <div class="cpimg"><img :src="api + item.productPhoto[0]" class="cpimg" alt=""></div>
            <div class="cpname">
              <div>{{ item.productModel }}</div>
              <div>{{ item.productName }}</div>
              <div style="font-size: larger;background-color: #008C3E;width: 30%;margin: auto;border-radius: 5px;margin-top:5px;color: #FFFFFF">查看详情</div>
            </div>
          </div>
        </div>
        <el-pagination
            v-show="total>0"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryParams.pageNum"
            :page-sizes="[10, 50, 100, 250]"
            :page-size="queryParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            style="text-align: center">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
let api = 'https://www.slfangshuijiao.com/api';
let deptId = 111;
export default {
  name: 'Cplist',
  data() {
    return {
      active_btn: 0,
      titName: '',
      visible: false,
      api,
      activeIndex: '1',
      activeIndex2: '1',
      form: {},
      cplist: [],
      rules: {},
      dataTime: '',
      imgList: [],
      columnData: [],
      outsideList: [],
      ruleForm: [],
      zxDialog: false,
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 12,
        type: '',
        gjz: '',
      },
      listData: [],
      typeList: [],
      columnId:'',
    }
  },
  created() {
    // this.titName = this.$route.query.name
  },
  mounted() {
    if (this.$route.query.name != '产品世界') {
      this.columnId = this.$route.query.id
    }
    console.log(888,this.$route.query);
    this.lmList()
    this.typesList()

  },
  methods: {
    newsList(index, item) {
      this.active_btn = index;
      this.titName = item.menuName;
      this.columnId = item.menuId
      // console.log('menuId',item.menuId);
      this.zxSubmit()
      // this.lmList(item.menuId, this.active_btn1)
      this.listData = this.listData[this.active_btn]
    },
    //跳转产品详情页面
    openDetails(item) {
      window.location = "/#/cpdetails?id=" + item.productId + '&name=' + encodeURI(item.productName) +
          '&index=' +  this.active_btn + '&menuId=' + this.columnId
    },
    //列表
    zxSubmit() {
      let that = this;
      that.$axios.post(api + '/site/productList?columnId=' + this.columnId + '&deptId=' + deptId
          + '&pageNum=' + this.queryParams.pageNum + '&pageSize=' + this.queryParams.pageSize
          + '&param=' + this.queryParams.gjz, {
        emulateJSON: true
      }).then(function (res) {
        if (res.data.code == '0') {
          if (res.data.data) {
            that.listData = res.data.data.rows
            that.listData.forEach(item => {
              item.productPhoto = item.productPhoto.split(',')
              // console.log('第一个图片',item.productPhoto)
            })
            that.total = res.data.data.total
          }
        } else {
          that.$message.error(res.message);
        }
      })
    },
    //类型
    typesList() {
      let that = this;
      that.$axios.post(api + '/site/productType?deptId=' + deptId, {
        emulateJSON: true
      }).then(function (res) {
        if (res.data.code == '0') {
          that.cplist = res.data.data
          if (res.data.data) {
            that.typeList = res.data.data
            that.titName = res.data.data[0].menuName
            // console.log(1111,res.data.data);

            //根据url中name动态匹配标签页
            if (that.$route.query.name != '产品世界'){
              that.cplist.forEach((item,index)=>{
                if (that.$route.query.name == item.menuName){
                  // console.log('下标--',index)
                  that.active_btn = index;

                }
              })
            }else{
              that.columnId = res.data.data[0].menuId
              // console.log(res.data.data[0].menuId);
            }
            that.columnId = that.$route.query.menuId
            that.active_btn = that.$route.query.index;

            that.zxSubmit()

            // that.$message.error(res.message);
          }
        } else {
          that.$message.error(res.message);
        }
      })
    },
    //栏目列表
    lmList() {
      let that = this;
      that.$axios.post(api + '/site/columnList?deptId=' + deptId, {
        emulateJSON: true
      }).then(function (res) {
        if (res.data.code == '0') {
          if (res.data.data) {
            var arr = []
            res.data.data.forEach(item => {
              if (item.visible == 0) {
                arr.push(item)
              }
            })
            // that.columnData = that.handleTree(arr, 'menuId', 'parentId')
          }
        } else {
          that.$message.error(res.message);
        }
      })
    },
    GetQueryString(str) {
      var reg = new RegExp("(^|&)" + str + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]);
      return null;
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val
      this.zxSubmit()
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val
      this.zxSubmit()
    }
  }
}
</script>
<style scoped>
/deep/ .el-input--suffix .el-input__inner {
  color: #606266;
}

.dqwz {
  line-height: 3;
  color: rgba(110, 110, 110, 1);
  font-size: 14px;
  float: right;
  padding: 0 65px;
}

/* //页面 */
.btcss {
  border-bottom: rgba(110, 110, 110, 1) solid 1px;
  background-color: #FFFFFF;
  margin-bottom: 0px;
}
.tabbox div{
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  width: calc(100%/5 - 50px)!important;
  -webkit-box-orient: vertical;
}
.tabbox {
  display: flex;
  width: 93%;
  float: left;
  padding: 0px 15px 0 15px;
  justify-content: space-between;
  margin-left: 70px;
  /*font-weight: bold;*/
}

.active {
  color: #008D40;
  font-weight: 600;
  border-bottom: #0dcc73 solid 3px;
}

.cpname {
  border-top: solid 1px #E8E8E8;
  background-color: #ffffff;
  text-align: center;
  padding: 15px;
  height: 85px;
}

.cpimg {
  height: 400px;
  width: 100%;
}

.cpb {
  padding: 15px 0;
  overflow: auto;
}

.cpbox:hover {
  border: solid 2px #DEE1E6;
}

.cpbox {
  border: solid 2px #ffffff;
  width: calc(100% / 4 - 35px);
  float: left;
  margin: 10px;
  cursor: pointer;
}

.mlbox {
  border-bottom: solid 1px #8E8E8E;
  padding: 10px 0;
}

.mlbox {
  font-size: 20px;
}

.mlbox > *:hover {
  color: red;
}

.lowerbox {
  padding: 25px;
  margin: 15px 0;
}

.ceneterbox {
  margin: auto;
  padding: 15px;
  background: #E6F3EA;
  /* margin-top: 1%!important; */
}

.flexbox {
  margin-left: 15%;
  display: flex;
  font-size: 18px;
  padding: 10px;
  cursor: pointer;
}

.flexbox:hover {
  color: red;
}

.ydbox {
  width: 20px;
  height: 20px;
  padding: 0 10px;
}

.cenbox {
  text-align: center;
}

.centerbox {
  overflow: auto;
  width: 50%;
  margin: auto;
  padding: 15px;
  height: 50%;
}

body,
html {
  height: 100%;
  margin: 0;
}

#app {
  /* height: 100%;
  width: 100%; */
  background-size: 100% 100%;
}

.bt {
  color: rgb(83, 75, 53);
  width: 100%;
  font-size: 23px;
  font-weight: bold;
  text-align: center;
  align-content: center;
  margin: 0;
}

/* 侧边栏 */
.cbbox {
  position: fixed;
  right: 0%;
  top: 50%;
  width: 100px;
  padding: 0px 0px 150px;
  z-index: 999;
}

.cbtb {
  width: 60px;
  height: 60px;
}

.el-dialog__wrapper {
  overflow: hidden;
}

.zxbox .el-dialog {
  left: 30% !important;
  margin-top: auto !important;
}

.zxbox .el-dialog__header {
  background-color: #009FED;
  padding: 0px;
}

.zxbox .el-dialog__title {
  color: #fff;
}

.zxbox .dialog-header-title {
  display: flex;
  border-radius: 10px;
}

.zxbox .el-dialog__close {
  color: #fff;
}

.zxbox {
  top: 35%;
}

.zxname {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  line-height: 40px;
  padding: 0 5px;
  line-height: 50px;
}

.el-form-item__content {
  text-align: center;
  padding: 5px;
}

.el-form-item {
  margin-bottom: 0px;
}

.el-popover,
.popper__arrow::after {
  padding: 0px;
  border-radius: 10px;
  background-color: rgb(0, 160, 233);
  border: 1px solid rgb(0, 160, 233)
}

.zxcha {
  line-height: 40px;
  font-size: 16px;
}

.zxhead {
  display: flex;
  color: #fff;
  background-color: rgb(0, 160, 233);
  border-radius: 10px;
}


.el-submenu__title:hover {
  color: red !important;
}


.el-submenu {
  font-weight: bold;
  margin-left: 4.5%;
}

.el-submenu__title:hover {
  background-color: initial !important;
}

@media screen and (max-width: 500px) {
  .ceneterbox {
    padding: 0px;
  }
  .cpb{
    padding: 0;
  }
  .cpboxz{
    width: calc(100% / 2 - 25px) !important;
  }
  ::v-deep.el-pagination .el-select .el-input{
    display: none !important;
  }
  .el-select>.el-input{
    display: none !important;
  }
  .el-pagination{
    white-space: normal !important;
  }
}
</style>
